<template>
  <div class="console_r">
    <div class="console_r_card" style="margin-bottom: 30px;">
      <div class="title">
          <b>密码设置</b>
      </div>
      <div class="con" style="padding-top: 25px">
        <div class="ipt_notes">
            <div class="ipt_wrap">
                <span>旧密码：</span>
                <el-input class="ipt" type="password" v-model="pwd" placeholder="请输入旧密码"></el-input>
            </div>
        </div>
        <div class="ipt_notes" style="display: flex">
            <div class="ipt_wrap">
                <span>新密码：</span>
                <el-input class="ipt" type="password" v-model="newPwd" placeholder="请输入新密码"></el-input>
            </div>
        </div>
        <div class="ipt_notes" style="display: flex">
            <div class="ipt_wrap">
                <span>确认密码：</span>
                <el-input class="ipt" type="password" v-model="confirmPwd" placeholder="请确认新密码"></el-input>
            </div>
        </div>
        <div class="ipt_notes" style="text-align: left; margin-top: 30px;">
            <sh-button class="button-a" @click="handleLogin">确 定</sh-button>
        </div>
      </div>
    </div>
    <div class="console_r_card">
      <div class="title">
          <b>个人设置</b>
      </div>
      <div class="con" style="padding-top: 25px">
        <div class="ipt_notes">
            <div class="ipt_wrap">
                <span>系统名称：</span>
                <el-input class="ipt" type="text" v-model="sysName" placeholder="请输入系统名称"></el-input>
            </div>
        </div>
        <div class="ipt_notes" style="text-align: left; margin-top: 30px;">
            <sh-button class="button-a" @click="modifyUserInfo">确 定</sh-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import { mapActions } from 'vuex'
import crypto from 'crypto'
import ShInput from '@/components/uikit/input'
import ShButton from '@/components/uikit/button'

export default {
  name: 'Login',
  components: {
    // ShInput,
    ShButton
  },
  data() {
    return {
      pwd: '',
      newPwd: '',
      confirmPwd: '',
      loding: false,
      sysName: this.$store.state.user.sysName
    }
  },
  methods: {
    ...mapActions([
      'modifyPwd',
      'modifyInfo'
    ]),
    handleLogin() {
      if(this.newPwd !== this.confirmPwd) {
        Message.error('两次输入的密码不一致')
        return
      }
      this.loding = true
      let hash = crypto.createHash('sha256')
      let hash2 = crypto.createHash('sha256')
      let old_password = hash.update(this.pwd).digest('hex')
      let new_password = hash2.update(this.newPwd).digest('hex')
      const params = {
        old_password,
        new_password
      }
      this.modifyPwd(params).then((res) => {
        this.loding = false
        const _this = this
        Message.success('密码修改成功，请重新登录')
        setTimeout(() => {
          _this.$router.push({
            name: 'login'
          })
        }, 1000)
      }).catch(err => {
        this.loding = false
      })
    },
    modifyUserInfo () {
      this.modifyInfo({sys_name: this.sysName}).then((res) => {
        Message.success('系统名称修改成功')
      }).catch(err => {
        Message.error('系统名称修改失败')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import 'poultry.scss';
.ipt_wrap {
    display: flex;
    align-items: center;
    span {
        width: 130px;
    }
}
.d-line {
    width: 100%;
    height: 1px;
    background-color: rgba(170, 182, 228, 0.5);
    margin: 50px 0;
}
</style>
